<div class="">

  <mat-form-field *ngIf="filter" class="p-2">
    <mat-label>Filtrar</mat-label>
    <input (keyup)="applyFilter($event)" matInput placeholder="Ex. 52468">
  </mat-form-field>

  <mat-table [dataSource]="dataSource" matSort>

    <ng-container *ngFor="let c of columns">

      <ng-container matColumnDef="{{c.name}}">

        <ng-container *ngIf="c.sort; else noSortBlock">
          <mat-header-cell *matHeaderCellDef class="justify-content-center"
                           mat-sort-header> {{c.label}} </mat-header-cell>
        </ng-container>
        <ng-template #noSortBlock>
          <mat-header-cell *matHeaderCellDef class="justify-content-center"> {{c.label}} </mat-header-cell>
        </ng-template>

        <mat-cell *matCellDef="let element">
          <ng-container [ngSwitch]="c.type">
            <ul *ngSwitchCase="'List'">
              <li *ngFor="let item of element[c.name]">{{item}}</li>
            </ul>
            <ng-container *ngSwitchCase="'Literal'">
              <div class="d-flex justify-content-center" style="flex: 1">
                <span innerHTML="{{element[c.name]}}"></span>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Action'">
              <div class="d-flex justify-content-center" style="flex: 1" *ngIf="element[c.name] && !element[c.name].actions">
                <button (click)="actionClick(element.__source__, element[c.name].value)" *ngIf="!!element[c.name]"
                        mat-icon-button
                        matTooltip="{{element[c.name].text}}">
                  <mat-icon>
                    <fa-icon icon="{{element[c.name].icon}}"></fa-icon>
                  </mat-icon>
                </button>
              </div>
              <div class="d-flex justify-content-center" style="flex: 1" *ngIf="element[c.name] && element[c.name].actions && element[c.name].actions.length > 0">
                <button [matMenuTriggerFor]="menu"
                        mat-icon-button>
                  <mat-icon>
                    <fa-icon icon="{{element[c.name].icon}}"></fa-icon>
                  </mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item *ngFor="let cAct of element[c.name].actions"
                          (click)="actionClick(element.__source__, cAct.value)">
                    <mat-icon *ngIf="cAct.icon">
                      <fa-icon icon="{{cAct.icon}}"></fa-icon>
                    </mat-icon>
                    <span>{{cAct.text}}</span>
                  </button>
                </mat-menu>
              </div>
            </ng-container>
            <ng-container *ngSwitchCase="'Check'">
              <div class="d-flex justify-content-center" style="flex: 1">
                <mat-checkbox (change)="$event ? selectionChange(element.__source__, element[c.name].value) : null"
                              (click)="$event.stopPropagation()" color="primary"
                >
                </mat-checkbox>
              </div>
            </ng-container>
            <span *ngSwitchDefault> :( </span>
          </ng-container>
        </mat-cell>

      </ng-container>

    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
  </mat-table>
  <div [hidden]="!pagination">
    <mat-paginator
      [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons [pageSize]="pageSize" [length]="totalCount" (page)="pageEvent = pageSelected($event)">
    </mat-paginator>
  </div>
</div>
